import { Router } from "express";

import { studentMobileController } from "../../controllers/mobile/student-mobile-controller";
import { authenticate, studentOnly } from "../../middleware/auth-middleware";
import { uploadMiddleware } from "../../middleware/upload-middleware";

const router = Router();

/**
 * Student Mobile Routes - Separate from school administrative flows
 * Base path: /api/mobile/student
 *
 * These routes are specifically designed for mobile applications
 * and do not interfere with school administrative workflows
 */

// Apply authentication middleware to all routes
router.use(authenticate);

// Apply student role validation to all routes
router.use(studentOnly);

/**
 * @route   POST /api/mobile/student/documents/remove
 * @desc    Remove specific documents from student profile using media IDs (Mobile App)
 * @access  Private - Student only
 * @body    { removeDocuments: string[] } - Array of media IDs to remove
 */
router.post(
  "/documents/remove",
  studentMobileController.removeStudentDocuments.bind(studentMobileController),
);

/**
 * @route   POST /api/mobile/student/profile/update
 * @desc    Update student profile with document changes (Mobile App)
 * @access  Private - Student only
 * @body    { removeDocuments: string[] } - Array of media IDs to remove
 */
router.post(
  "/profile/update",
  studentMobileController.updateStudentProfile.bind(studentMobileController),
);

/**
 * @route   GET /api/mobile/student/profile
 * @desc    Get student profile (Mobile App)
 * @access  Private - Student only
 */
router.get(
  "/profile",
  studentMobileController.getStudentProfile.bind(studentMobileController),
);

/**
 * @route   PUT /api/mobile/student/profile
 * @desc    Update student profile (Mobile App)
 * @access  Private - Student only
 */
router.put(
  "/profile",
  studentMobileController.updateProfile.bind(studentMobileController),
);

/**
 * @route   GET /api/mobile/student/assignments
 * @desc    Get student's assignments (Mobile App)
 * @access  Private - Student only
 */
router.get(
  "/assignments",
  studentMobileController.getAssignments.bind(studentMobileController),
);

/**
 * @route   GET /api/mobile/student/attendance
 * @desc    Get student's attendance (Mobile App)
 * @access  Private - Student only
 */
router.get(
  "/attendance",
  studentMobileController.getAttendance.bind(studentMobileController),
);

/**
 * @route   GET /api/mobile/student/quizzes
 * @desc    Get student's quizzes (Mobile App)
 * @access  Private - Student only
 */
router.get(
  "/quizzes",
  studentMobileController.getQuizzes.bind(studentMobileController),
);

/**
 * @route   GET /api/mobile/student/progress-report
 * @desc    Get student's progress report with assignments, quizzes, and class performance (Mobile App)
 * @access  Private - Student only
 */
router.get(
  "/progress-report",
  studentMobileController.getProgressReport.bind(studentMobileController),
);

/**
 * @route   POST /api/mobile/student/absence-request
 * @desc    Create absence/leave request with document upload (Mobile App)
 * @access  Private - Student only
 * @body    FormData with leaveType, startDate, endDate, reason, and optional document file(s)
 */
router.post(
  "/absence-request",
  uploadMiddleware.array("document", 5), // Allow up to 5 documents
  studentMobileController.createAbsenceRequest.bind(studentMobileController),
);

export { router as studentMobileRoutes };
